// actions.js
import * as actionTypes from "./actionsTypes"

export const setValueBaseCalcul = newValue => ({
  type: actionTypes.SET_VALUE_BASE_CALCUL,
  payload: newValue,
})

export const setCurrentPageBaseCalcul = newCurrentPage => ({
  type: actionTypes.SET_CURRENT_PAGE_BASE_CALCUL,
  payload: newCurrentPage,
})

export const setPageSizeBaseCalcul = newValue => ({
  type: actionTypes.SET_PAGE_SIZE_BASE_CALCUL,
  payload: newValue,
})
export const setSortingBaseCalcul = newValue => ({
  type: actionTypes.SET_SORTING_BASE_CALCUL,
  payload: newValue,
})
export const setCustomFilterBaseCalcul = newValue => ({
  type: actionTypes.SET_CUSTOM_FILTERS_BASE_CALCUL,
  payload: newValue,
})
export const setSortFieldBaseCalcul = newSortField => ({
  type: actionTypes.SET_SORT_FIELD_BASE_CALCUL,
  payload: newSortField,
})
export const setOrderBaseCalcul = newOrder => ({
  type: actionTypes.SET_ORDER_BASE_CALCUL,
  payload: newOrder,
})
export const setColumnBaseCalcul = newValue => ({
  type: actionTypes.SET_COLUMN_BASE_CALCUL,
  payload: newValue,
})
//
export const setQueryBaseCalcul = newQuery => ({
  type: actionTypes.SET_QUERY_BASE_CALCUL,
  payload: newQuery,
})
export const setActifBaseCalcul = newQuery => ({
  type: actionTypes.SET_ACTIF_BASE_CALCUL,
  payload: newQuery,
})
export const setSelectedOptionFiltersBaseCalcul = newQuery => ({
  type: actionTypes.SET_SELECTED_OPTION_FILTERS_BASE_CALCUL,
  payload: newQuery,
})
export const setSelectedOptionIdBaseCalcul = newQuery => ({
  type: actionTypes.SET_SELECTED_OPTION_ID_BASE_CALCUL,
  payload: newQuery,
})
